import { apiClient } from '../apiClient';

export type ApiUser = {
  id: string;
  email: string;
  display_name: string;
  is_hr: boolean;
};

type MicrosoftExchangePayload = {
  access_token?: string;
  id_token: string;
};

export const exchangeMicrosoftAuthToken = (payload: MicrosoftExchangePayload) =>
  apiClient.post<ApiUser>('/auth/microsoft/exchange', payload);

export const getCurrentUser = () => apiClient.get<ApiUser>('/me');
